export const WEB_LOGIN_MODES = {
    FIT_TO_PLAY: 'fit-to-play'
}